import { FormattedMessage } from 'react-intl'
import DoublePointTakeoverLogo from './components/DoublePointTakeoverLogo'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import DoublePointTakeoverBackground from './components/DoublePointTakeoverBackground'
import DoublePointTakeoverSubtitleContent from './components/DoublePointTakeoverSubtitleContent'
import DoublePointTakeoverTitleContent from './components/DoublePointTakeoverTitleContent'
import DoublePointTakeoverBannerContent from './components/DoublePointTakeoverBannerContent'
import { SOCIETE_DOUBLE_POINTS_TAKEOVER_ID } from './constants/societeDoublePointsTakeoverConstants'
import DoublePointTakeoverSearchBanner from './components/DoublePointTakeoverSearchBanner'

export const doublePointCampaignId = 'double points December 2025'

const societeDoublePointsTakeoverConfig: App.SiteTakeoverConfig = {
  id: SOCIETE_DOUBLE_POINTS_TAKEOVER_ID,
  palette: 'default',
  verticals: new Set(['home', 'hotel', 'tours', 'cruise']),
  offerTypes: new Set([
    'hotel',
    'cruise',
    'tour', // Tour V1
    'direct_tour', 'partner_tour', 'connection_tour', // Tour V2
    'experience',
  ]),
  backgroundElement: DoublePointTakeoverBackground,
  siteWide: {
    banner: {
      description: <DoublePointTakeoverBannerContent />,
      align: 'start',
      tabletAlign: 'center',
      logo: undefined,
      showOnHomePage: true,
      palette: 'inverse',
    },
  },
  searchPage: {
    bannerContent: <DoublePointTakeoverSearchBanner />,
    hideOnMobileScreenSize: true,
  },
  offerPage: {
    bannerContent: <DoublePointTakeoverBannerContent />,
  },
  campaignTags: new Set([doublePointCampaignId]),
  heroSection: {
    title: <DoublePointTakeoverTitleContent />,
    subtitle: <DoublePointTakeoverSubtitleContent />,
    logo: <CSSBreakpoint min="tablet"><DoublePointTakeoverLogo size="medium" /></CSSBreakpoint>,
    palette: 'default',
    verticals: new Set(['home']),
    filters: [
      {
        label: <FormattedMessage
          id="vR-FwdDoM43qc_e25fj5"
          defaultMessage="Dining & Drinks"
          description="Filter label for dining and drinks holiday type on double points takeover"
        />,
        value: 'Dining & Drinks',
        type: 'holidayType',
      },
      {
        label: <FormattedMessage
          id="N0HF9Vsiv73Lk8FTRNqc"
          defaultMessage="Family Friendly"
          description="Filter label for family friendly holiday type on double points takeover"
        />,
        value: 'Family Friendly',
        type: 'holidayType',
      },
      {
        label: <FormattedMessage
          id="xEVEVw4MT8FJecOFBXs7"
          defaultMessage="Sun & Beach"
          description="Filter label for sun and beach holiday type on double points takeover"
        />,
        value: 'Sun & Beach',
        type: 'holidayType',
      },
    ],
  },
}

export default societeDoublePointsTakeoverConfig
